// Mock seeded data for UNIDEX frontend demo.
// All data lives client-side; mutations only persist in memory for the session.

export const OFFERS = [
  { id: 1, name: "CRM & Sales Automation", icp: "sales director, B2B, consulting firm, pipeline, CRM, account manager" },
  { id: 2, name: "Multi-Channel Bot", icp: "e-commerce brand, WhatsApp, customer support, clinic, orders, Telegram" },
  { id: 3, name: "Reporting Dashboard", icp: "marketing agency, reporting, client accounts, Google Ads, Meta ads, multilingual" },
  { id: 4, name: "Knowledge Base", icp: "law firm, consulting, proposals, document management, legal, SharePoint" },
  { id: 5, name: "E-Commerce Ops", icp: "D2C, Shopify, EU market, VAT, logistics, cross-border, WooCommerce" },
  { id: 6, name: "Candidate Screening", icp: "recruitment agency, HR director, staffing, ATS, hiring, talent acquisition" },
  { id: 7, name: "Payment & Billing", icp: "SaaS founder, fintech, invoicing, billing, subscription, recurring revenue" },
  { id: 8, name: "Web Scraping & Intel", icp: "market research, investment analyst, price monitoring, competitive intelligence" },
  { id: 9, name: "ERP / Operations", icp: "hotel owner, restaurant chain, construction, logistics director, facilities" },
  { id: 10, name: "Talent Platform", icp: "HR tech startup, job board, talent platform founder, recruitment software" },
  { id: 11, name: "Operations Monitoring", icp: "retail chain, warehouse, multi-location, facilities manager, physical operations" },
  { id: 12, name: "Subscription Payments", icp: "membership platform, online course, SaaS, churn, recurring billing" },
];

// V3 status vocabulary — see UNIDEX_V3_System_Redesign_Plan.docx section 5.1.
// A contact is never auto-removed from rotation for not accepting an
// invite (no "REJECTED"/expiry status exists); CLOSED_LOST is the only
// way out, and it's always a manual call from the Inbox/Contacts UI.
export const STATUSES = [
  "NEW",
  "DISQUALIFIED",
  "RESEARCHED",
  "INVITED",
  "CONNECTED",
  "SENT",
  "FOLLOWED_UP",
  "REPLIED",
  "CLOSED_LOST",
];

export const AUDIENCE_TYPES = ["agency_owner", "early_stage", "entrepreneur", "client"];

export const SCORES = ["HIGH", "MEDIUM_HIGH", "MEDIUM", "LOW_MEDIUM", "LOW"];

export const AGENTS = [
  {
    id: 1,
    name: "Daniel Voss",
    active: true,
    maturity: "mature",
    persona:
      "Operations automation specialist helping logistics and supply chain companies in Eastern Europe streamline cross-border workflows.",
    unipileAccount: "li-acc-1a2b3c",
    outputMirror: "agent_daniel_contacts",
    inputWorksheet: "leads_q2_eu_logistics",
    tickSchedule: 15,
    pauseReason: null,
    offers: [1, 2, 5, 8, 9, 11],
    stats: { totalContacts: 1284, queuedMsgs: 14, sentToday: 12, lastTick: "2026-06-04T09:21:00Z" },
    statusBreakdown: { IMPORTED: 420, RESEARCHED: 188, CLASSIFIED: 142, QUEUED: 64, SENT: 312, REPLIED: 118, MEETING_BOOKED: 22, CLOSED_LOST: 18 },
    limits: { dm: 15, invite: 20, like: 100, comment: 30, dmSpacing: 90, inviteSpacing: 120 },
  },
  {
    id: 2,
    name: "Mira Holland",
    active: true,
    maturity: "warm",
    persona:
      "B2B SaaS GTM advisor working with founders shipping subscription products to mid-market.",
    unipileAccount: "li-acc-2d3e4f",
    outputMirror: "agent_mira_contacts",
    inputWorksheet: "leads_q2_saas_founders",
    tickSchedule: 20,
    pauseReason: null,
    offers: [1, 3, 7, 10, 12],
    stats: { totalContacts: 842, queuedMsgs: 7, sentToday: 4, lastTick: "2026-06-04T08:48:00Z" },
    statusBreakdown: { IMPORTED: 260, RESEARCHED: 130, CLASSIFIED: 96, QUEUED: 32, SENT: 210, REPLIED: 78, MEETING_BOOKED: 24, CLOSED_LOST: 12 },
    limits: { dm: 5, invite: 10, like: 50, comment: 15, dmSpacing: 180, inviteSpacing: 240 },
  },
  {
    id: 3,
    name: "Anton Karpov",
    active: false,
    maturity: "cold",
    persona: "New account warming up — legal & professional services focus.",
    unipileAccount: "li-acc-5g6h7i",
    outputMirror: "agent_anton_contacts",
    inputWorksheet: "leads_q2_law_firms",
    tickSchedule: 30,
    pauseReason: "Manual pause for warmup. Resume after 7 days.",
    offers: [4, 6, 7],
    stats: { totalContacts: 188, queuedMsgs: 0, sentToday: 0, lastTick: "2026-06-02T17:10:00Z" },
    statusBreakdown: { IMPORTED: 120, RESEARCHED: 38, CLASSIFIED: 18, QUEUED: 0, SENT: 12, REPLIED: 0, MEETING_BOOKED: 0, CLOSED_LOST: 0 },
    limits: { dm: 2, invite: 5, like: 20, comment: 5, dmSpacing: 360, inviteSpacing: 480 },
  },
  {
    id: 4,
    name: "Leona Patel",
    active: true,
    maturity: "mature",
    persona: "RevOps & analytics partner for marketing agencies running performance ads at scale.",
    unipileAccount: "li-acc-8j9k0l",
    outputMirror: "agent_leona_contacts",
    inputWorksheet: "leads_q2_ad_agencies",
    tickSchedule: 15,
    pauseReason: null,
    offers: [3, 6, 8, 10],
    stats: { totalContacts: 974, queuedMsgs: 9, sentToday: 8, lastTick: "2026-06-04T09:05:00Z" },
    statusBreakdown: { IMPORTED: 290, RESEARCHED: 152, CLASSIFIED: 110, QUEUED: 28, SENT: 244, REPLIED: 94, MEETING_BOOKED: 31, CLOSED_LOST: 25 },
    limits: { dm: 12, invite: 18, like: 90, comment: 26, dmSpacing: 100, inviteSpacing: 150 },
  },
];

const firstNames = ["Igor", "Sofia", "Ben", "Aiko", "Marek", "Lena", "Tomas", "Priya", "Hugo", "Ines", "Nikolai", "Adele", "Caleb", "Rumi", "Selin", "Owen", "Kira", "Joao", "Maya", "Felix"];
const lastNames = ["Ortega", "Vihaan", "Park", "Schroeder", "Larsen", "Kovac", "Bauer", "Iyer", "Hayashi", "Bram", "Vargas", "Trifu", "Petrov", "Quinn", "Aslan", "Tan", "Mendez", "Dvorak", "Romano", "Klein"];
const headlines = [
  "Head of Sales · B2B SaaS",
  "Founder, marketing operations agency",
  "VP People · 200+ FTE staffing",
  "Operations Director · logistics",
  "CMO at fintech",
  "Co-founder · subscription billing",
  "Head of Growth · D2C consumer",
  "Partner, M&A consulting",
  "RevOps lead",
  "GM, EU retail",
  "Founder, talent platform",
  "Procurement lead, hospitality",
];
const companies = [
  "Northwind Logistics",
  "Crescent Labs",
  "Helix Recruit",
  "Voltage Studio",
  "Cobalt Pay",
  "Northern Press",
  "Tessera Group",
  "Vertex Talent",
  "Atlas Retail",
  "Brightline AI",
];

function seedRand(seed) {
  let x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

function generateContacts(agentId, count) {
  const out = [];
  for (let i = 0; i < count; i++) {
    const r = seedRand(agentId * 1000 + i);
    const r2 = seedRand(agentId * 2000 + i);
    const fn = firstNames[Math.floor(r * firstNames.length)];
    const ln = lastNames[Math.floor(r2 * lastNames.length)];
    const head = headlines[Math.floor(seedRand(i * 7 + agentId) * headlines.length)];
    const comp = companies[Math.floor(seedRand(i * 13 + agentId) * companies.length)];
    const status = STATUSES[Math.floor(seedRand(i * 3 + agentId * 17) * STATUSES.length)];
    const offer = Math.floor(seedRand(i * 5 + agentId * 11) * 12) + 1;
    const audience = AUDIENCE_TYPES[Math.floor(seedRand(i * 11 + agentId * 5) * AUDIENCE_TYPES.length)];
    const score = SCORES[Math.floor(seedRand(i * 23 + agentId) * SCORES.length)];
    const day = (i % 28) + 1;
    out.push({
      id: agentId * 10000 + i + 1,
      agentId,
      name: `${fn} ${ln}`,
      headline: `${head} at ${comp}`,
      company: comp,
      status,
      offer,
      audience,
      score,
      createdAt: `2026-05-${String(day).padStart(2, "0")}`,
      updatedAt: `2026-06-${String(((i % 4) + 1)).padStart(2, "0")}`,
      linkedinUrl: `https://linkedin.com/in/${fn.toLowerCase()}-${ln.toLowerCase()}`,
    });
  }
  return out;
}

export const CONTACTS = [
  ...generateContacts(1, 142),
  ...generateContacts(2, 96),
  ...generateContacts(3, 24),
  ...generateContacts(4, 118),
];

// V3: no more import/warmup/blitz/generate ticks. invite_tick and dm_tick
// run continuously ("according to availability") rather than on a fixed
// calendar — see UNIDEX_V3_System_Redesign_Plan.docx.
export const TICK_TYPES = ["classify", "invite", "relationship_check", "dm", "send", "discover"];

function generateTickRuns(agentId, count) {
  const out = [];
  for (let i = 0; i < count; i++) {
    const type = TICK_TYPES[Math.floor(seedRand(agentId + i * 3) * TICK_TYPES.length)];
    const errors = seedRand(agentId * 7 + i) > 0.85 ? Math.floor(seedRand(i) * 3) + 1 : 0;
    const processed = Math.floor(seedRand(i * 5 + agentId) * 80) + 10;
    const actions = Math.floor(processed * (0.4 + seedRand(i + agentId) * 0.4));
    const hour = (8 + (i % 12));
    const minute = ((i * 7) % 60);
    out.push({
      id: agentId * 100 + i,
      agentId,
      type,
      startedAt: `2026-06-0${(i % 4) + 1} ${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:00Z`,
      finishedAt: i === 0 ? null : `2026-06-0${(i % 4) + 1} ${String(hour).padStart(2, "0")}:${String(minute + 2).padStart(2, "0")}:00Z`,
      processed,
      actions,
      errors,
      ok: errors === 0,
    });
  }
  return out;
}

export const TICK_RUNS = [
  ...generateTickRuns(1, 20),
  ...generateTickRuns(2, 15),
  ...generateTickRuns(3, 8),
  ...generateTickRuns(4, 18),
];

// Conversations / messages — for Inbox
function generateConversation(contactId, agentId, numMessages) {
  const contact = CONTACTS.find((c) => c.id === contactId);
  const messages = [];
  for (let i = 0; i < numMessages; i++) {
    const outbound = i % 2 === 0;
    messages.push({
      id: contactId * 100 + i,
      outbound,
      text: outbound
        ? `Hey ${contact.name.split(" ")[0]}, noticed your work on ${contact.company} — would love to compare notes on how your team is handling outreach at scale. Open to a quick 15-min next week?`
        : `Sounds interesting — what specifically were you thinking? We've been looking at automation but careful about message quality.`,
      ts: `2026-06-0${(i % 3) + 1}T${String(9 + i * 2).padStart(2, "0")}:1${i % 9}:00Z`,
    });
  }
  return { contactId, agentId, messages, lastMessageAt: messages[messages.length - 1].ts };
}

const _conversationsSeeds = [
  { contactId: 10001, agentId: 1, n: 6, unread: true },
  { contactId: 10003, agentId: 1, n: 4, unread: false },
  { contactId: 10005, agentId: 1, n: 3, unread: true },
  { contactId: 10008, agentId: 1, n: 5, unread: false },
  { contactId: 20001, agentId: 2, n: 7, unread: true },
  { contactId: 20002, agentId: 2, n: 2, unread: false },
  { contactId: 20004, agentId: 2, n: 4, unread: false },
  { contactId: 40001, agentId: 4, n: 5, unread: true },
  { contactId: 40002, agentId: 4, n: 3, unread: false },
  { contactId: 40006, agentId: 4, n: 6, unread: false },
];

export const CONVERSATIONS = _conversationsSeeds.map((s) => {
  const c = generateConversation(s.contactId, s.agentId, s.n);
  c.unread = s.unread;
  c.lastSnippet = c.messages[c.messages.length - 1].text;
  return c;
});

export const UNREAD_COUNT = CONVERSATIONS.filter((c) => c.unread).length;

// Templates
const SEGMENTS = ["agency", "founder", "client"];
const AUDIENCES = ["cold", "followup"];

export const DEFAULT_TEMPLATES = {};
for (const aud of AUDIENCES) {
  for (const seg of SEGMENTS) {
    DEFAULT_TEMPLATES[`${aud}_template_${seg}`] = `Hi {first_name}, saw you're leading ${seg} efforts at {company} — we help teams like yours cut outreach prep by ~70%. Worth a quick chat? — ${aud === "cold" ? "Initial intro" : "Followup nudge"}.`;
  }
  for (let i = 1; i <= 12; i++) {
    DEFAULT_TEMPLATES[`${aud}_template_offer_${i}`] = `Hi {first_name}, given your role at {company} and our work on Offer ${i} (${OFFERS[i - 1].name}), thought there might be a fit. Open to a 15-min call next week?`;
  }
}

// Blitz history & schedule
export const BLITZ_AUTOMATIC_DEFAULT = true;
export const BLITZ_HISTORY = [
  { id: 1, date: "2026-06-01 09:00:00Z", agentId: 1, mode: "Automatic", sent: 87, errors: 1, duration: "2m 14s" },
  { id: 2, date: "2026-06-01 09:00:00Z", agentId: 2, mode: "Automatic", sent: 64, errors: 0, duration: "1m 48s" },
  { id: 3, date: "2026-06-01 09:00:00Z", agentId: 4, mode: "Automatic", sent: 91, errors: 2, duration: "2m 22s" },
  { id: 4, date: "2026-05-25 09:00:00Z", agentId: 1, mode: "Automatic", sent: 82, errors: 0, duration: "2m 10s" },
  { id: 5, date: "2026-05-25 09:00:00Z", agentId: 2, mode: "Manual", sent: 55, errors: 0, duration: "1m 32s" },
  { id: 6, date: "2026-05-18 09:00:00Z", agentId: 4, mode: "Automatic", sent: 88, errors: 1, duration: "2m 19s" },
];

export const DISCOVERY_HISTORY = [
  { id: 1, date: "2026-06-04 08:00:00Z", agentId: 1, queriesRun: 24, found: 48, duplicatesSkipped: 9, errors: 0 },
  { id: 2, date: "2026-06-04 08:00:00Z", agentId: 2, queriesRun: 20, found: 31, duplicatesSkipped: 6, errors: 1 },
  { id: 3, date: "2026-06-04 08:00:00Z", agentId: 4, queriesRun: 26, found: 52, duplicatesSkipped: 11, errors: 0 },
  { id: 4, date: "2026-06-03 08:00:00Z", agentId: 1, queriesRun: 24, found: 42, duplicatesSkipped: 14, errors: 0 },
  { id: 5, date: "2026-06-03 08:00:00Z", agentId: 2, queriesRun: 20, found: 28, duplicatesSkipped: 8, errors: 0 },
];

export const POSTING_QUEUE = [
  { id: 1, status: "Scheduled", agentName: "Daniel Voss", scheduledFor: "2026-06-05 09:00", caption: "How we cut DM reply latency by 38% running a structured weekly blitz across…", media: "image" },
  { id: 2, status: "Draft", agentName: "Mira Holland", scheduledFor: "—", caption: "Three patterns we keep seeing in SaaS founders who actually close cold pipeline…", media: null },
  { id: 3, status: "Posted", agentName: "Leona Patel", scheduledFor: "2026-06-02 10:30", caption: "Why every performance agency should run a weekly reporting digest — and the 4…", media: "image" },
  { id: 4, status: "Scheduled", agentName: "Daniel Voss", scheduledFor: "2026-06-07 14:00", caption: "Note from a recent ops review: most logistics teams underestimate where automation…", media: null },
  { id: 5, status: "Failed", agentName: "Anton Karpov", scheduledFor: "2026-06-01 08:00", caption: "Legal teams: 6 prompts you can run today to extract clauses from a contract…", media: "image" },
];

// Settings keys (masked values)
export const SETTINGS = [
  { key: "UNIPILE_DSN", secret: false, help: "Unipile API base URL (e.g. https://api31.unipile.com)", current: "https://api31.unipile.com" },
  { key: "UNIPILE_API_KEY", secret: true, help: "Unipile API key", current: "************************a4f2" },
  { key: "OPENAI_API_KEY", secret: true, help: "OpenAI API key", current: "sk-****************************df21" },
  { key: "OPENAI_MODEL_GENERATION", secret: false, help: "Model name for message generation", current: "gpt-5.4-mini" },
  { key: "OPENAI_MODEL_CLASSIFICATION", secret: false, help: "Model name for classification", current: "gpt-5.4-nano" },
  { key: "GOOGLE_SHEETS_ID", secret: false, help: "Google Spreadsheet ID", current: "1xKf...8s2" },
  { key: "TELEGRAM_BOT_TOKEN", secret: true, help: "Telegram bot token", current: "*************************XaQ" },
  { key: "TELEGRAM_CHAT_ID", secret: false, help: "Telegram chat ID for notifications", current: "-100184429..." },
];

// Chrome 3D image assets used decoratively per design guidelines
export const CHROME_IMAGES = {
  loginHero:
    "https://images.unsplash.com/photo-1707567019592-a05a41cc0b52?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  emptyState:
    "https://images.pexels.com/photos/9888046/pexels-photo-9888046.jpeg?auto=compress&cs=tinysrgb&w=900",
  headerDecor:
    "https://images.unsplash.com/photo-1739056238917-d89cd05c48d5?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
};

export function agentById(id) {
  return AGENTS.find((a) => a.id === Number(id));
}
export function contactsForAgent(id) {
  return CONTACTS.filter((c) => c.agentId === Number(id));
}
export function tickRunsForAgent(id) {
  return TICK_RUNS.filter((t) => t.agentId === Number(id));
}
export function conversationsForAgent(id) {
  return CONVERSATIONS.filter((c) => c.agentId === Number(id));
}
